import React from 'react';
import PropTypes from 'prop-types';

const PlanType = ({
  planName,
  type,
  buttonTitle,
  planTitle,
  handlePlan,
  blurb,
  description,
}) => (
  <div className="plan-type">
    {type === 'free' && (
      <div className="plan-type-content">
        <div>
          <div>
            <div className="plan">Free</div>
            <div className="price">$0</div>
            <div className="desc text-left">
              Create unlimited copyright split sheets with your collaborators -
              simple one page agreements that can cover all of your content
              (videos, music, literature, images).
            </div>
          </div>
          <br />
          <ul className="text-left">
            <li>
              <br />
              Establish the percentage of your copyrights that each collaborator
              owns.
            </li>
            <li>
              Build, negotiate, and e-sign your split sheets with your
              collaborators with Cosynd's easy step-by-step process .
            </li>
            <li>Add new titles to your existing split sheets at any time.</li>
          </ul>
        </div>
        <button onClick={() => handlePlan('free')}>{buttonTitle}</button>
      </div>
    )}

    {type !== 'free' && (
      <div className="plan-type-content">
        <div>
          <div>
            <div className="plan">{planName}</div>
            <div className="price">{planTitle}</div>
            <div className="desc text-center">{blurb}</div>
          </div>
          <br />
          <ul className="text-left">
            <li>{description}</li>
          </ul>
        </div>
        <button onClick={() => handlePlan(type)}>{buttonTitle}</button>
      </div>
    )}
  </div>
);

PlanType.defaultProps = {
  buttonTitle: 'Select Plan',
};

PlanType.propTypes = {
  buttonTitle: PropTypes.string,
};

export default PlanType;



// WEBPACK FOOTER //
// src/components/UserPlan/PlanType.jsx